export default "__VITE_ASSET__BO$BL87O__"